import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e560540"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "atbd-top-dropdwon" }
const _hoisted_2 = {
  key: 0,
  class: "atbd-top-dropdwon-titulo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "titulo-texto" }, "Notificações", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "ss-alinhar-centro"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "atbd-top-dropdwon-nav notificacao-bs-list"
}
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = { class: "atbd-top-dropdwon-content notificacoes" }
const _hoisted_11 = {
  key: 0,
  class: "notificacao-bs-icon bg-primary"
}
const _hoisted_12 = {
  key: 1,
  class: "notificacao-bs-icon bg-primary"
}
const _hoisted_13 = { class: "ss-abreviacao-recurso" }
const _hoisted_14 = { class: "notificacao-bs-content d-flex" }
const _hoisted_15 = { class: "notificacao-bs-texto" }
const _hoisted_16 = { class: "notificacao-bs-status" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_badge = _resolveComponent("a-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.storeSistema.state.layoutMobile)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.state.buscandoNotificacoes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_a_spin, { size: "large" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.state.notificacoes.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_a_empty, { description: 'Você não possui nenhuma notificação.' }, null, 8, ["description"])
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.notificacoes, (notificacao) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: notificacao.codigo
                  }, [
                    _createElementVNode("a", {
                      title: notificacao.mensagem,
                      onClick: ($event: any) => (_ctx.acessarLinkNotificacao(notificacao))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        (notificacao.icone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_icone, {
                                nome: notificacao.icone
                              }, null, 8, ["nome"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.obterAbreviacaoRecurso(notificacao.recurso)), 1)
                            ])),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h1", null, _toDisplayString(notificacao.titulo), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(notificacao.dataCriacao)), 1),
                            _createElementVNode("h2", null, _toDisplayString(notificacao.mensagem), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_badge, {
                              color: _ctx.obterCorNotificacao(notificacao.tipo),
                              dot: ""
                            }, null, 8, ["color"])
                          ])
                        ])
                      ])
                    ], 8, _hoisted_9)
                  ]))
                }), 128))
              ]))
        ])),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "ant-btn ant-btn-secondary",
          style: {"width":"100%","margin-top":"10px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.visualizarTodasNotificacoes && _ctx.visualizarTodasNotificacoes(...args)))
        }, "Ver todas")
      ])
    ])
  ]))
}